import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { Installation } from '@ubie/core';

@Component({
  selector: 'acl-card-header',
  standalone: false,
  templateUrl: './card-header.component.html',
  styleUrl: './card-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardHeaderComponent {
  readonly icon = input<string>('');
  readonly text = input<string>('');
  readonly subText = input<string | undefined>(undefined);

  // get installation data from admin-pages and assigned to local var if data exist and if not call the service and get data
  readonly installationData = input<Installation | undefined>(undefined);

  readonly displayText = computed(
    () => this.text()?.trim() || this.installationData()?.name?.trim() || '',
  );
}
